import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './version.component.html',
    standalone: false
})
export class VersionPageComponent extends BaseModalPageComponent implements OnInit {
  constructor(location: Location, private router: Router) {
    super(location);
  }

  ngOnInit(): void {}

  close(): void {
    this.router.navigate([this.settingsRoute]);
  }
}
